module.exports = __webpack_public_path__ + "img/shouyebg2.be33dcab.jpg";